export default __webpack_public_path__ + "static/media/Breastplate of the Living Tarim.3566b68a.jpg";